<!-- global markup for header -->
<header class="header">
	<div class="content">
		<div class="header__block row">
			<div class="header__arrow col image" (click)="handleNavigation()"><img src="/assets/images/header/back-arrow.svg" alt="arrow" /><span style="color: white; font-size: 18px">חזרה</span></div>
			<div class="header__title col">מכירות לקוחות לפי קבוצה</div>
			<div class="header__burger col image">
				<!-- <img src="/assets/images/header/burger.svg" alt="burger"> -->
			</div>
		</div>
	</div>
	<!-- <div class="report-table__row">
		<div class="header__search header__search_small" style="width: 99%; margin: auto; margin-top: 10px">
			<form [formGroup]="form">
				<input
					class="header__search-input"
					type="text"
					[placeholder]="windowWidth > 768 ? 'חפש לפי שם/קוד פריט' : 'חפש'"
					formControlName="Search"
					id="search-Input"
					style="text-align: center; direction: rtl"
				/>
			</form>
			<button class="header__clear-icon" (click)="SearchClear()"></button>
		</div>
	</div> -->
</header>

<!-- start report table markup -->
<section class="report-table">
	<div class="content">
		<div class="flex-row" style="margin-top: 40px">
			<!-- <div *ngIf="ShowCompanys !==null">

				<form [formGroup]="form" (change)="ChangeCompany()">
			<select formControlName="Company" style="width: 150px;height: 35px;">
			  <option *ngFor="let c of ShowCompanys" value="{{c.Company}}">{{c.CompanyName}}</option>
			</select>
		</form>

		</div> -->
			<app-excel-button (clicked)="onExcelDownload()"></app-excel-button>
		</div>

		<!-- <div class="flex-row">סינון סוכנים</div> -->

		<div class="report-table__row report-table__row_full-width" style="margin-right: 0px" #reportTableWrapper>
			<table class="report-table__table" cellspacing="0">
				<thead class="report-table__table-head">
					<tr>
						<th class="report-table__table-head-name" style="width: 200px">קבוצה</th>
						<th class="report-table__table-head-name" style="width: 110px">יעד שנתי</th>
						<th class="report-table__table-head-name" style="width: 110px">מצטבר {{ year }}</th>
						<th class="report-table__table-head-name" style="width: 80px">תחזית מול ביצוע</th>
						<th class="report-table__table-head-name" style="width: 110px">מצטבר {{ year - 1 }}</th>
						<th class="report-table__table-head-name" style="width: 80px">השוואה לאשתקד</th>
					</tr>
				</thead>
				<tbody class="report-table__table-body">
					<ng-container *ngFor="let group of allClientGoalsDisplay$ | async">
						<tr>
							<td class="report-table__table-body-name">
								{{ group.groupId }} - {{ group.groupName || 'ללא שם' }}
								<button [color]="group.isOpenClients ? 'primary' : null" mat-icon-button (click)="toggleGroup(group.groupId)">
									<mat-icon>groups</mat-icon>
								</button>
								<button [color]="group.isOpenGroupOnly ? 'primary' : null" mat-icon-button (click)="toggleOnlyGroup(group.groupId)">
									<mat-icon>timeline</mat-icon>
								</button>
								<!-- <button class="order-product__item-info-count-button" [ngClass]="{ 'order-product__item-info-count-button_add': !group.isOpen }" (click)="toggleGroup(group.groupId)"></button> -->
							</td>
							<td class="report-table__table-body-name">{{ group.currentYearGoal | number }}</td>
							<td class="report-table__table-body-name">{{ group.total | number }}</td>
							<td class="report-table__table-body-name">{{ group.advancementPercentage | number : '1.0-2' }}</td>
							<td class="report-table__table-body-name">{{ group.lastYearTotal | number }}</td>
							<td class="report-table__table-body-name">{{ group.growthPercentage | number : '1.0-2' }}</td>
						</tr>
						<div style="min-width: 96vw" class="table-wrapper" *ngIf="group.isOpenClients" #groupTableWrapper>
							<table class="report-table__table">
								<thead class="report-table__table-head">
									<tr>
										<th class="report-table__table-head-name" style="width: 200px">שם לקוח</th>
										<th class="report-table__table-head-name" style="width: 110px">יעד שנתי</th>
										<th class="report-table__table-head-name" style="width: 110px">מצטבר {{ year }}</th>
										<th class="report-table__table-head-name" style="width: 80px">תחזית מול ביצוע</th>
										<th class="report-table__table-head-name" style="width: 110px">מצטבר {{ year - 1 }}</th>
										<th class="report-table__table-head-name" style="width: 80px">השוואה לאשתקד</th>
									</tr>
								</thead>
								<tbody class="report-table__table-body">
									<ng-container *ngFor="let client of clientsUnderGroup$ | async">
										<tr>
											<td class="report-table__table-body-name">
												{{ client.clientName }}
												<button
													class="order-product__item-info-count-button"
													[ngClass]="{ 'order-product__item-info-count-button_add': !client.isOpenGroupOnly }"
													(click)="toggleClient(client.clientId)"
												></button>
											</td>
											<td class="report-table__table-body-name">{{ client.currentYearGoal | number }}</td>
											<td class="report-table__table-body-name">{{ client.total | number }}</td>
											<td class="report-table__table-body-name">{{ client.advancementPercentage | number : '1.0-2' }}</td>
											<td class="report-table__table-body-name">{{ client.lastYearTotal | number }}</td>
											<td class="report-table__table-body-name">{{ client.growthPercentage | number : '1.0-2' }}</td>
										</tr>
										<div style="min-width: 90vw" class="table-wrapper" *ngIf="client.isOpenGroupOnly" #clientTableWrapper>
											<table class="report-table__table">
												<thead class="report-table__table-head">
													<tr>
														<th class="report-table__table-head-name" style="width: 80px">חודש</th>
														<th class="report-table__table-head-name" style="width: 110px">יעד</th>
														<th class="report-table__table-head-name" style="width: 110px">{{ year }}</th>
														<th class="report-table__table-head-name" style="width: 80px">תחזית מול ביצוע</th>
														<th class="report-table__table-head-name" style="width: 110px">{{ year - 1 }}</th>
														<th class="report-table__table-head-name" style="width: 80px">השוואה לאשתקד</th>
													</tr>
												</thead>
												<tbody class="report-table__table-body">
													<ng-container *ngFor="let goal of monthlyGoalsOfSelectedClientOrGroup$ | async">
														<tr>
															<td class="report-table__table-body-name">
																{{ goal.month | returnHebrewDate : 'month' : true }}
															</td>
															<td class="report-table__table-body-name">{{ goal.currentYearGoal | number }}</td>
															<td class="report-table__table-body-name">{{ goal.total | number }}</td>
															<td class="report-table__table-body-name">{{ goal.advancementPercentage | number : '1.0-2' }}</td>
															<td class="report-table__table-body-name">{{ goal.lastYearTotal | number }}</td>
															<td class="report-table__table-body-name">{{ goal.growthPercentage | number : '1.0-2' }}</td>
														</tr>
													</ng-container>
												</tbody>
											</table>
										</div>
									</ng-container>
								</tbody>
							</table>
						</div>
						<div style="min-width: 90vw" class="table-wrapper" *ngIf="group.isOpenGroupOnly" #onlyGroupTableWrapper>
							<table class="report-table__table">
								<thead class="report-table__table-head">
									<tr>
										<th class="report-table__table-head-name" style="width: 80px">חודש</th>
										<th class="report-table__table-head-name" style="width: 110px">יעד</th>
										<th class="report-table__table-head-name" style="width: 110px">{{ year }}</th>
										<th class="report-table__table-head-name" style="width: 80px">תחזית מול ביצוע</th>
										<th class="report-table__table-head-name" style="width: 110px">{{ year - 1 }}</th>
										<th class="report-table__table-head-name" style="width: 80px">השוואה לאשתקד</th>
									</tr>
								</thead>
								<tbody class="report-table__table-body">
									<ng-container *ngFor="let goal of monthlyGoalsOfSelectedClientOrGroup$ | async">
										<tr>
											<td class="report-table__table-body-name">
												{{ goal.month | returnHebrewDate : 'month' : true }}
											</td>
											<td class="report-table__table-body-name">{{ goal.currentYearGoal | number }}</td>
											<td class="report-table__table-body-name">{{ goal.total | number }}</td>
											<td class="report-table__table-body-name">{{ goal.advancementPercentage | number : '1.0-2' }}</td>
											<td class="report-table__table-body-name">{{ goal.lastYearTotal | number }}</td>
											<td class="report-table__table-body-name">{{ goal.growthPercentage | number : '1.0-2' }}</td>
										</tr>
									</ng-container>
								</tbody>
							</table>
						</div>
					</ng-container>
				</tbody>
			</table>
		</div>
	</div>
</section>
<!-- end report table markup -->
